import React from 'react';
import './styles.css';
import './subtitle.css';
import './typography.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import BackgroundImageStyles from './backgroundImageStyles';
import { useSubtitleClasses } from './useSubtitleClasses';
import { addStyle, getTrackingAttributes } from '../SharedUtils/utils';
import {
  renderSubTitle,
  renderFeaturedHeading,
  renderPrimaryHeading,
  renderSecondaryHeading,
  renderText,
  renderCtaLink,
} from './fieldsRenderer';

import { addBackgroundColorVariables } from '../SharedUtils/themeColors';
import { useTheme, useInvertedColor, useInvertedButton } from '../SharedUtils/hooks';

const FullWidthRichText = ({ fields, rendering }) => {
  const componentId = `c-${rendering.uid}`;

  const { isLight } = useTheme();

  const widgetStyles = {};
  const widgetClasses = [
    'o-widget',
    'c-full-width-rich-text',
    'small-text-center',
    'background-color-theme',
  ];
  const subTitleClasses = useSubtitleClasses('c-full-width-rich-text__subtitle', fields);

  const isCtaInverted = useInvertedButton(fields);
  const isColorInverted = useInvertedColor(fields);

  addBackgroundColorVariables(fields, widgetStyles);

  const isNarrowContainer = fields.NarrowContainer?.value;

  addStyle(widgetStyles, '--full-width-rich-text-padding-top', fields.PaddingTop?.value);
  addStyle(widgetStyles, '--full-width-rich-text-padding-bottom', fields.PaddingBottom?.value);

  if (fields.BackgroundImageCover?.value) widgetClasses.push('has-background-covered');
  if (isColorInverted) widgetClasses.push('is-inverted');
  if (fields.ImageHorizontalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageHorizontalAlignment.fields.value.value);
  if (fields.ImageVerticalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageVerticalAlignment.fields.value.value);
  if (fields.EnableMarginBottom?.value) widgetClasses.push('has-margin-bottom');
  if (fields.TextAlignCentered?.value) widgetClasses.push('u-text-center');

  const trackingAttributes = getTrackingAttributes(fields);

  return (
    <div
      id={componentId}
      className={widgetClasses.join(' ')}
      style={widgetStyles}
      {...RenderingStyling(rendering.componentName)}
    >
      <div className="c-container">
        <div className="full-width-wrapper">
          {renderSubTitle({ field: fields.SubTitle, classes: subTitleClasses })}
          {renderFeaturedHeading({
            field: fields.FeatureHeading,
            classes:
              'c-full-width-rich-text__feature-heading u-text-feature-title-lg u-text-feature-title-md u-text-feature-title-sm',
          })}
          {renderPrimaryHeading({
            fields: fields,
            classes: 'c-full-width-rich-text__primary-heading',
          })}
          {renderSecondaryHeading({
            field: fields.SecondaryHeading,
            classes: 'c-full-width-rich-text__secondary-heading',
            isHeading: true,
          })}
          {renderText({
            field: fields.Text,
            classes: 'c-full-width-rich-text__text',
            isNarrow: isNarrowContainer,
          })}
          {renderCtaLink({
            field: fields.CallToAction,
            isInverted: isCtaInverted,
            tracking: trackingAttributes,
          })}
        </div>
      </div>

      <BackgroundImageStyles componentId={componentId} fields={fields} isLight={isLight} />
    </div>
  );
};

export default FullWidthRichText;
